import { render, staticRenderFns } from "./AddPaySetting.vue?vue&type=template&id=42e138db&scoped=true"
import script from "./AddPaySetting.vue?vue&type=script&lang=js"
export * from "./AddPaySetting.vue?vue&type=script&lang=js"
import style0 from "./AddPaySetting.vue?vue&type=style&index=0&id=42e138db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e138db",
  null
  
)

export default component.exports